import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const S = {
  Wrapper: styled.div`
    display: flex;
    align-items: center;
    min-height: 88px;
    padding: 24px 40px;
    background-color: ${({ theme }) => theme.palette.hexToRgb(theme.palette.blueGrey[50], 0.5)};
  `,
  Strong: styled.strong`
    margin-right: 16px;
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 700;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
  HelperText: styled(Typography)`
    margin-right: auto;
    color: ${({ theme }) => theme.palette.grey[700]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
  Button: styled.button``,
};

const GuideBox = ({ className, text, children }) => (
  <S.Wrapper className={className}>
    <S.Strong>{text.strong}</S.Strong>
    <S.HelperText>{text.helper}</S.HelperText>
    {children}
  </S.Wrapper>
);

GuideBox.propTypes = {
  className: PropTypes.string,
  text: PropTypes.shape({
    strong: PropTypes.node,
    helper: PropTypes.node,
    button: PropTypes.node,
  }),
  children: PropTypes.node,
};

GuideBox.defaultProps = {
  className: undefined,
  text: {},
  children: undefined,
};

export default GuideBox;
